module.exports = __webpack_public_path__ + "static/media/flame.8466869e.svg";